import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import useMediaQuery from '@mui/material/useMediaQuery';

const selectSx = {
  height: '40px',
  borderRadius: '8px',
  fontSize: '0.875rem',
  minWidth: 170,
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E0E0E0' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
};

/**
 * CompanyFilters - Barra de filtros da listagem de empresas (Admin Geral)
 * @param {Object} props
 * @param {string} props.searchInput
 * @param {Function} props.onSearchChange
 * @param {string} props.status
 * @param {Function} props.onStatusChange
 * @param {string} props.isTest
 * @param {Function} props.onIsTestChange
 * @param {string} props.closure
 * @param {Function} props.onClosureChange
 * @param {string} props.sortValue
 * @param {Function} props.onSortChange
 */
function CompanyFilters({
  searchInput,
  onSearchChange,
  status,
  onStatusChange,
  isTest,
  onIsTestChange,
  closure,
  onClosureChange,
  sortValue,
  onSortChange,
}) {
  const isMobile = useMediaQuery('(max-width: 1100px)');

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        borderBottom: '1px solid #E8ECF0',
        bgcolor: '#fff',
      }}
    >
      <TextField
        size="small"
        placeholder="Buscar por id, nome ou e-mail da empresa"
        value={searchInput}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.disabled', fontSize: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          flex: 1,
          minWidth: 220,
          maxWidth: { sm: 420 },
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#fff',
            height: '40px',
            '& fieldset': { borderColor: '#E0E0E0' },
            '&:hover fieldset': { borderColor: '#BDBDBD' },
            '&.Mui-focused fieldset': { borderColor: 'primary.main' },
          },
          '& input': { fontSize: '0.875rem' },
        }}
      />

      <Select
        size="small"
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
        sx={selectSx}
      >
        <MenuItem value="all">Todos os status</MenuItem>
        <MenuItem value="active">Ativas</MenuItem>
        <MenuItem value="inactive">Inativas</MenuItem>
        <MenuItem value="never_accessed">Nunca acessaram</MenuItem>
      </Select>

      <Select
        size="small"
        value={isTest}
        onChange={(e) => onIsTestChange(e.target.value)}
        sx={selectSx}
      >
        <MenuItem value="all">Todas</MenuItem>
        <MenuItem value="1">Somente teste</MenuItem>
        <MenuItem value="0">Sem teste</MenuItem>
      </Select>

      <Select
        size="small"
        value={closure}
        onChange={(e) => onClosureChange(e.target.value)}
        sx={selectSx}
      >
        <MenuItem value="all">Todos os encerramentos</MenuItem>
        <MenuItem value="grace">Em encerramento</MenuItem>
        <MenuItem value="expired">Carência vencida</MenuItem>
        <MenuItem value="none">Sem encerramento</MenuItem>
      </Select>

      <Select
        size="small"
        value={sortValue}
        onChange={(e) => onSortChange(e.target.value)}
        sx={selectSx}
      >
        <MenuItem value="created_at_desc">Mais recentes</MenuItem>
        <MenuItem value="created_at_asc">Mais antigas</MenuItem>
        <MenuItem value="last_login_at_desc">Último login</MenuItem>
      </Select>
    </Box>
  );
}

export default CompanyFilters;
